module.exports = __webpack_public_path__ + "img/IMGP8634B.4d4549a0.jpg";